<template>
	<NuxtLayout name="404"> Error </NuxtLayout>
</template>

<script setup lang="ts"></script>

<style lang="scss"></style>
